import { VesselList } from '../common-components/manage-vessel-lists/vessel-lists.model';
import store from '../store';
import { VESSEL_COLOUR_WHITE } from './vessel-constants.utils';
import { getUserVesselPreferenceColour } from './vessel-styling.utils';

export const isValidHexColor = (color: string | undefined | null): boolean =>
  !!color && /^#[0-9A-F]{6}$/i.test(color);

export const getFallbackColor = (): string => {
  const { userPreferences } = store.getState().userPreferences;
  const preferenceVesselColour = getUserVesselPreferenceColour(userPreferences);
  return preferenceVesselColour || VESSEL_COLOUR_WHITE;
};

export const validHexColor = (
  vesselLists: VesselList[],
  filteredListIds: string[]
): string => {
  const fallbackColor = getFallbackColor();

  const matchingFilteredList = filteredListIds
    .map((listId) => vesselLists.find((list) => list.list_id === listId))
    .find((list) => list !== undefined);

  if (matchingFilteredList) {
    if (isValidHexColor(matchingFilteredList.list_colour)) {
      return matchingFilteredList.list_colour!;
    }
    return getFallbackColor();
  }

  const firstValidListColour = vesselLists
    .map((list) => list.list_colour)
    .find((color) => isValidHexColor(color));

  return firstValidListColour || fallbackColor;
};

export const getValidHexColorForList = (list: VesselList): string =>
  isValidHexColor(list.list_colour) ? list.list_colour! : getFallbackColor();
